import { boolean } from "@storybook/addon-knobs";
import React from "react";
import classNames from "classnames";
import Markdown from "markdown-to-jsx";

import styles from "./LargeTextHeader.module.scss";
import { Title } from "../Title";
import { CreativeMarkdown } from "../CreativeMarkdown";

interface LargeTextHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  rightAlign?: boolean;
  children: string;
}

const LargeTextHeader: React.FC<LargeTextHeaderProps> = ({
  rightAlign,
  children,
  className,
  title,
  ...props
}) => {
  return (
    <section
      className={classNames(
        styles.section,
        { [styles.right]: rightAlign },
        className
      )}
      {...props}
    >
      {title && (
        <Title tagName="h1" light size="xlarge" className={styles.title}>
          {title}
        </Title>
      )}
      <CreativeMarkdown className={styles.inner}>{children}</CreativeMarkdown>
    </section>
  );
};

export { LargeTextHeader };
